import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import axios from "axios";
import Dropzone from "react-dropzone";
import lodash from "lodash";
import ActiveSelect from "../general/ActiveSelect.js";
import Loading from "../general/Loading.js";
import LocationSelect from "../general/LocationSelect.js";
import Search from "../general/Search.js";
import DateTd from "../table-componets/DateTd.js";
import LinkTd from "../table-componets/LinkTd.js";
import NewCertificationModal from "./NewCertificationModal.js";
import NewSaiCertificationModal from "./NewSaiCertificationModal/NewSaiCertificationModal.js";
import NewCertificationTypeModal from "./NewCertificationTypeModal";
import CertificationTypeSelect from "./CertificationTypeSelect.js";
import CertificationRangeSelect from "./CertificationRangeSelect.js";
import ProgramDirectorSelect from "./ProgramDirectorSelect.js";
import InstructorTrainerSelect from "./InstructorTrainerSelect.js";
import TrainingCenterSelect from "./TrainingCenterSelect.js";
import SaiToggle from "./SaiIndex/SaiToggle.jsx";
import StandardCertificationsIndex from "./StandardCertificationsIndex.jsx";
import SaiCertificationsIndex from "./SaiIndex/SaiCertificationsIndex.jsx";
import Actions from "./Actions";
import SaiActions from "./SaiAdminPortal/SaiActions";

class Certifications extends React.Component {
  state = {
    selectedLocationId: "",
    searchText: "",
    certificationRange: "",
    certificationType: "",
    active: 1,
    page: 1,
    perPage: 25,
    totalPages: 1,
    orderBy: "users-last_name",
    orderDir: "ASC",
    selectedCertification: {},
    selectedCertificationType: {},
    selectedCertificationUser: {},
    certifications: [],
    uploadedFile: [],
    issueDate: null,
    expirationDate: null,
    loading: true,
    certificationTypes: this.props.certification_types.filter(
      (certificationType) => certificationType.is_sai !== true
    ),
    saiCertificationTypes: this.props.certification_types.filter(
      (certificationType) => certificationType.is_sai == true
    ),
    saiCertificationGroupsTypesSteps: this.props.saiCertificationGroupsTypesSteps,
    viewSaiOnly: this.props.accountIsSai.toString(),
    certificationTypeId: ''
  };

  componentDidMount() {
    this.buildData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.certificationTypeId !== this.state.certificationTypeId || prevState.issueDate !== this.state.issueDate) {
      const certificationType = this.state.certificationTypes.find(c => c.id == +this.state.certificationTypeId);
      if (certificationType && certificationType.valid_for_duration && certificationType.valid_for_units && this.state.issueDate) {
        let issueDate = new Date(this.state.issueDate);
        let expirationDate;
        switch (certificationType.valid_for_units) {
          case 'days':
            expirationDate = new Date(issueDate.setDate(issueDate.getDate() + certificationType.valid_for_duration));
            break;
          case 'weeks':
            expirationDate = new Date(issueDate.setDate(issueDate.getDate() + certificationType.valid_for_duration * 7));
            break;
          case 'months':
            expirationDate = new Date(issueDate.setMonth(issueDate.getMonth() + certificationType.valid_for_duration));
            break;
          case 'years':
            expirationDate = new Date(issueDate.setFullYear(issueDate.getFullYear() + certificationType.valid_for_duration));
            break;
        }
        if (expirationDate) {
          $('#editExpirationDatePicker').data('kendoDatePicker').value(expirationDate);

          this.setState({
            expirationDate: expirationDate
          });
        }
      }
    }
  }

  newLocation(newLocation) {
    this.setState({
      loading: true,
      selectedLocationId: newLocation,
      page: 1
    });
    this.buildData();
  }

  newProgramDirector(newProgramDirector) {
    this.setState({
      loading: true,
      selectedProgramDirector: newProgramDirector,
      page: 1
    });
    this.buildData();
  }

  newInstructorTrainer(newInstructorTrainer) {
    this.setState({
      loading: true,
      selectedInstructorTrainer: newInstructorTrainer,
      page: 1
    });
    this.buildData();
  }

  newTrainingCenter(newTrainingCenter) {
    this.setState({
      loading: true,
      selectedTrainingCenter: newTrainingCenter,
      page: 1
    });
    this.buildData();
  }

  newSearch(newSearch) {
    this.setState({
      loading: true,
      searchText: newSearch,
      page: 1
    });
    this.buildData();
  }

  newCertificationRange(newCertificationRange) {
    this.setState({
      loading: true,
      certificationRange: newCertificationRange,
      page: 1
    });
    this.buildData();
  }

  newCertificationType(newCertificationType) {
    this.setState({
      loading: true,
      certificationType: newCertificationType,
      page: 1
    });
    this.buildData();
  }

  newActive(newActive) {
    if (newActive == "true") {
      var active = 1;
    } else if (newActive == "false") {
      var active = 0;
    } else {
      var active = null;
    }

    this.setState({
      loading: true,
      active: active,
      page: 1
    });
    this.buildData();
  }

  toggleSaiCertifications(value) {

    this.setState({
      loading: true,
      viewSaiOnly: value,
      page: 1
    });
    this.buildData();
  }

  changePage(increment) {
    var page = this.state.page + increment;
    this.setState({ page: page });
    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      50
    );
  }

  saveCertification() {
    var that = this;

    var formData = new FormData();

    formData.append(
      "certification[expiration_date]",
      that.state.expirationDate
    );

    formData.append(
      "certification[certification_type_id]",
      that.state.certificationTypeId
    );

    formData.append(
      "certification[provider_certification_id]",
      that.state.providerCertificationId
    );

    if (that.state.issueDate) {
      formData.append(
        "certification[issue_date]",
        that.state.issueDate
      );
    }

    if (that.state.uploadedFile.preview) {
      formData.append(
        "certification[attachment]",
        that.state.uploadedFile
      );
    }

    var config = {
      headers: { "content-type": "multipart/form-data" }
    };

    axios
      .put(
        "/certifications/" + that.state.selectedCertification.id,
        formData,
        config
      )
      .then(function(response) {
        var certifications = that.state.certifications;
        certifications[that.state.selectedCertification.index] = response.data;
        that.setState({ certifications: certifications });

        $("#editCertificationModal").modal("hide");

        var issueDatePicker = $("#editIssueDatePicker").data("kendoDatePicker");
        issueDatePicker.value(null);

        var expirationDatePicker = $("#editExpirationDatePicker").data(
          "kendoDatePicker"
        );
        expirationDatePicker.value(null);

        that.setState({
          uploadedFile: []
        });

        toastr.success("Certification updated");
      })
      .catch(function(error) {
        toastr.error("Certification not updated");
        console.log(error);
      });
  }

  onDrop(acceptedFiles, rejectedFiles) {
    if (acceptedFiles && acceptedFiles[0]) {
      toastr.success("Processing file...");

      this.setState({
        uploadedFile: acceptedFiles[0]
      });
    }

    if (rejectedFiles && rejectedFiles[0]) {
      toastr.error("File type not supported");
    }
  }

  renderFilePreview() {
    if (
      this.state.uploadedFile.preview &&
      this.state.uploadedFile.type != "application/pdf"
    ) {
      return (
        <div>
          <br />
          <img
            src={this.state.uploadedFile.preview}
            alt="Uploaded file preview"
            className="hidden-xs hidden-sm"
            height="125"
          />
          <img
            src={this.state.uploadedFile.preview}
            alt="Uploaded file preview"
            className="visible-xs visible-sm"
            height="50"
          />
        </div>
      );
    } else if (
      this.state.uploadedFile.preview &&
      this.state.uploadedFile.type == "application/pdf"
    ) {
      return (
        <div>
          <br />
          Attachment: {this.state.uploadedFile.name}
        </div>
      );
    } else {
      return <span />;
    }
  }

  render() {
    const {
      certificationTypes,
      saiCertificationTypes,
      saiCertificationGroupsTypesSteps
    } = this.state;

    var that = this;

    return (
      <div>
        <h1>Certifications</h1>
        <div className="row">
          <LocationSelect
            locationId={this.props.locationId}
            locations={this.props.locations}
            selectClassName="col-md-3 col-xs-12"
            newLocationCallback={newLocation => this.newLocation(newLocation)}
          />
          <Search newSearchCallback={newSearch => this.newSearch(newSearch)} />
          <div className="col-md-6 pull-right">
            {this.state.viewSaiOnly == "true" ? (
              <SaiActions
                locationId={this.state.selectedLocationId}
                active={this.state.active || ""}
                accountIsSai={this.props.accountIsSai}
                saiAdminPortal={false}
              />
            ) : (
              <Actions
                locationId={this.state.selectedLocationId}
                active={this.state.active || ""}
                accountIsSai={this.props.accountIsSai}
              />
            )}
          </div>
        </div>
        <div className="row">
          <CertificationTypeSelect
            certificationTypes={this.state.viewSaiOnly == "true" ? saiCertificationTypes : certificationTypes}
            newCertificationTypeCallback={newCertificationType =>
              this.newCertificationType(newCertificationType)
            }
          />
          <CertificationRangeSelect
            newCertificationRangeCallback={newCertificationRange =>
              this.newCertificationRange(newCertificationRange)
            }
          />
          <ActiveSelect
            newActiveCallback={newActive => this.newActive(newActive)}
          />


          {this.props.accountIsSai &&
            <div>
              <SaiToggle
                viewSaiOnly={this.state.viewSaiOnly}
                newSaiToggleCallback={toggleSaiCertifications =>
                  this.toggleSaiCertifications(toggleSaiCertifications)
                }
              />
            </div>
          }
        </div>
        {this.state.viewSaiOnly == "true" &&
          <div className="row">
            <ProgramDirectorSelect
              programDirectorId={0}
              programDirectors={this.props.programDirectors}
              selectClassName="col-md-3 col-xs-12"
              newProgramDirectorCallback={newProgramDirector => this.newProgramDirector(newProgramDirector)}
            />
            <InstructorTrainerSelect
              instructorTrainerId={0}
              instructorTrainers={this.props.instructorTrainers}
              selectClassName="col-md-3 col-xs-12"
              newInstructorTrainerCallback={newInstructorTrainer => this.newInstructorTrainer(newInstructorTrainer)}
            />
            <TrainingCenterSelect
              trainingCenterId={0}
              trainingCenters={this.props.trainingCenters}
              selectClassName="col-md-3 col-xs-12"
              newTrainingCenterCallback={newTrainingCenter => this.newTrainingCenter(newTrainingCenter)}
            />
          </div>
        }

        <br />
        {this.state.certifications.length && this.state.loading != true ? (
          <div>
            {this.state.viewSaiOnly == "true" ? (
              <SaiCertificationsIndex
                certifications={this.state.certifications}
                handlerDelete={this.handlerDelete}
                openEditModal={this.openEditModal}
                sortData={this.sortData}
                programDirectors={this.props.programDirectors}
                instructorTrainers={this.props.instructorTrainers}
                trainingCenters={this.props.trainingCenters}
                updateCertificationStepResult={this.updateCertificationStepResult}
              />
            ) : (
              <StandardCertificationsIndex
                certifications={this.state.certifications}
                handlerDelete={this.handlerDelete}
                openEditModal={this.openEditModal}
                sortData={this.sortData}
              />
            )}
            <div>
              <p>
                {"Showing page " + this.state.page + " of " + this.state.totalPages}
              </p>
              {this.state.page == 1 && (
                <a className="btn btn-default disabled">
                  <i className="material-icons progress-bar-icon">
                    keyboard_arrow_left
                  </i>
                </a>
              )}
              {this.state.page != 1 && (
                <a href="#" className="btn btn-default" onClick={() => this.changePage(-1)}>
                  <i className="material-icons progress-bar-icon">
                    keyboard_arrow_left
                  </i>
                </a>
              )}
              {this.state.page < this.state.totalPages && (
                <a href="#" className="btn btn-default" onClick={() => this.changePage(1)}>
                  <i className="material-icons progress-bar-icon">
                    keyboard_arrow_right
                  </i>
                </a>
              )}
              {this.state.page == this.state.totalPages && (
                <a className="btn btn-default disabled">
                  <i className="material-icons progress-bar-icon">
                    keyboard_arrow_right
                  </i>
                </a>
              )}
            </div>

            <div className="modal fade" id="editCertificationModal">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h1 className="modal-title">
                      {this.state.selectedCertificationType.name}
                      <br />
                      {this.state.selectedCertificationUser.last_name +
                        ", " +
                        this.state.selectedCertificationUser.first_name}
                    </h1>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-xs-12">
                        <select className='form-control'
                          title='select certification type'
                          name='certificationTypeId'
                          value={this.state.certificationTypeId}
                          onChange={e => (this.setState({certificationTypeId: e.target.value}))}
                        >
                          {this.state.certificationTypes.map((certificationType) => (
                            <option key={certificationType.id} value={certificationType.id}>
                              {certificationType.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-xs-12">
                        <label htmlFor="cert-edit-modal-provider-certification-id">Provider Certification ID</label>
                        <br />
                        <input
                          id="cert-edit-modal-provider-certification-id"
                          value={this.state.providerCertificationId || ""}
                          onChange={e => {
                            this.setState({
                              providerCertificationId: e.target.value
                            });
                          }}
                          className="form-control"
                        />
                      </div>

                      <div className="col-xs-12 col-md-6">
                        <label id="cert-edit-issue-date-label" for="editIssueDatePicker">Issue Date</label>
                        <br />
                        <input
                          id="editIssueDatePicker"
                          className="full-width"
                          aria-labelledby="cert-edit-issue-date-label"
                        />
                      </div>
                      <div className="col-xs-12 col-md-6">
                        <label id="cert-edit-exp-date-label" for="editExpirationDatePicker">Expiration Date *</label>
                        <br />
                        <input
                          id="editExpirationDatePicker"
                          className="full-width"
                          aria-labelledby="cert-edit-exp-date-label"
                        />
                      </div>
                      {this.state.selectedCertification
                        .attachment_file_name && (
                        <div className="col-xs-12 col-md-12">
                          <br />
                          <label>Attachment</label>
                          <br />
                          <a
                            href={
                              this.state.selectedCertification.attachment_url
                            }
                            className="styled-link pointer-hand"
                            target="_blank"
                          >
                            <span className="material-icons md-20 icon-for-btn">
                              attachment
                            </span>
                            {
                              this.state.selectedCertification
                                .attachment_file_name
                            }
                          </a>
                        </div>
                      )}
                    </div>
                    <br />
                    <label id="edit-certification-attachment" className="control-label">Attachment(s)</label>
                    <Dropzone
                      name="edit-certification-dropzone"
                      className="dropzone dq-dropzone pointer-hand"
                      acceptClassName="dq-dropzone-accepted"
                      rejectClassName="dq-dropzone-rejected"
                      accept="application/pdf, image/*"
                      multiple={false}
                      disablePreview={false}
                      onDrop={function(acceptedFiles, rejectedFiles) {
                        that.onDrop(acceptedFiles, rejectedFiles);
                      }}
                      inputProps={{'aria-labelledby': 'edit-certification-attachment'}}
                    >
                      <center className="grey-text">
                        <br />
                        <h4>Drop file here or click to upload.</h4>
                        <p>Existing file will be replaced on upload.</p>
                        <br />
                      </center>
                    </Dropzone>
                    {this.renderFilePreview()}
                  </div>
                  <div className="modal-footer">
                    {moment(this.state.issueDate).isAfter(
                      moment(this.state.expirationDate)
                    ) ? (
                      <p className="pink-text center-text">
                        Check issue and expiration dates.
                      </p>
                    ) : (
                      <span />
                    )}
                    <button
                      type="button"
                      className="btn btn-pink full-width"
                      onClick={function() {
                        that.saveCertification();
                      }}
                    >
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Loading
            loading={this.state.loading}
            noDataMessage="No certifications"
          />
        )}

        {this.props.accountIsSai &&
          <NewSaiCertificationModal
            saiCertificationGroupsTypesSteps={saiCertificationGroupsTypesSteps}
            programDirectors={this.props.programDirectors}
            instructorTrainers={this.props.instructorTrainers}
            trainingCenters={this.props.trainingCenters}
            employees={this.props.employees}
            onAdded={this.handlerCertificationAdded}
          />
        }

        <NewCertificationModal
          certificationTypes={certificationTypes}
          onAdded={this.handlerCertificationAdded}
        />

        <NewCertificationTypeModal
          onAdded={this.handlerCertificationTypeAdded}
        />
      </div>
    );
  }

  updateCertificationStepResult = (certification, stepResult, index) => {
    var certifications = this.state.certifications;
    certifications[index].expiration_date = certification.expiration_date;
    certifications[index]["latest_certification_step_result"] = stepResult;
    this.setState({certifications: certifications});
  };

  handlerCertificationTypeAdded = data => {
    const tmp = this.state.certificationTypes;
    tmp.push(data);
    this.setState({ certificationTypes: tmp });
  };

  handlerCertificationAdded = data => {
    toastr.success("Certification created");
    this.buildData();
  };

  handlerDelete = certification => {
    var that = this;

    if (!confirm("Are you sure you want to delete this certification?")) {
      return;
    }

    if (this.props.accountIsSai) {
      axios.delete(`/certifications/${certification.id}`).then(
        function(response) {
          toastr.error("Certification deleted");
          that.buildData();
        }
      );
    } else {
      const certifications = this.state.certifications;
      lodash.remove(certifications, { id: certification.id });
      this.setState({ certifications: certifications });

      toastr.error("Certification deleted");

      axios.delete(`/certifications/${certification.id}`)
    };
  };

  openEditModal = (certification, index) => {
    var that = this;

    if (certification.issue_date) {
      var issueDate = moment(certification.issue_date).format();
    } else {
      var issueDate = null;
    }

    $("#editIssueDatePicker").kendoDatePicker({
      value: issueDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          issueDate: value
        });
      }
    });

    $("#editExpirationDatePicker").kendoDatePicker({
      value: moment(certification.expiration_date).format(),

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          expirationDate: value
        });
      }
    });

    certification.index = index;

    this.setState({ selectedCertification: certification });
    this.setState({
      selectedCertificationType: certification.certification_type
    });
    this.setState({ selectedCertificationUser: certification.user });
    this.setState({ issueDate: certification.issue_date });
    this.setState({ expirationDate: certification.expiration_date });
    this.setState({ certificationTypeId: certification.certification_type_id });
    this.setState({ providerCertificationId: certification.provider_certification_id });

    $("#editCertificationModal").modal("show");
  }

  sortData = (orderBy) => {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == "DESC") {
        this.setState({ orderDir: "ASC" });
      } else {
        this.setState({ orderDir: "DESC" });
      }
    } else {
      this.setState({ orderBy: orderBy });
      this.setState({ orderDir: "DESC" });
    }

    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      50
    );
  }

  buildData= () => {
    var that = this;

    var params = {
      page: this.state.page,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir
    };

    if (this.state.selectedLocationId) {
      params["location_id"] = this.state.selectedLocationId;
    }

    if (this.state.searchText) {
      params["search"] = this.state.searchText;
    }

    if (this.state.certificationRange) {
      params["certification_range"] = this.state.certificationRange;
    }

    if (this.state.certificationType) {
      params["certification_type_id"] = this.state.certificationType;
    }

    if (this.state.active != null) {
      params["active"] = this.state.active;
    }

    if (this.state.selectedProgramDirector) {
      params["program_director_id"] = this.state.selectedProgramDirector;
    }

    if (this.state.selectedInstructorTrainer) {
      params["instructor_trainer_id"] = this.state.selectedInstructorTrainer;
    }

    if (this.state.selectedTrainingCenter) {
      params["training_center_id"] = this.state.selectedTrainingCenter;
    }

    params["sai_only"] = this.state.viewSaiOnly;

    axios({
      method: "get",
      url: "/certifications.json",
      params: params,
      responseType: "json"
    }).then(function(response) {
      that.setState({
        loading: false,
        certifications: response.data,
        totalPages: Math.ceil(response.headers.total / that.state.perPage)
      });
    });
  }
}

Certifications.propTypes = {
  certification_types: PropTypes.array,
  sai_certifications: PropTypes.array,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  locations: PropTypes.array,
  employees: PropTypes.array
};

export default Certifications;
